module.exports = __webpack_public_path__ + "static/media/count10Off_118.6b807eef.png";